import { Recipient } from 'plugin-reports-maker/webapp/js/common/types/form'
import { OptionType } from '../../LookupsList/LookupSelect'

export function mapRecipientToOptionType(recipient: Recipient): OptionType {
    return {
        label: recipient.name,
        value: recipient.uuid
    } as OptionType
}

export function recipientToOptionsType(recipients: Recipient[]): OptionType[] {
    return recipients.sort(compareToSortRecipients).map(recipient => mapRecipientToOptionType(recipient))
}

export function compareToSortRecipients(a: Recipient, b: Recipient): number {
    return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
}
export function getRecipientSelected(uids: string[], options: Recipient[]): Recipient[] {
    return options.filter(option => uids.includes(option.uuid)).sort(compareToSortRecipients)
}
